import React, { Component } from 'react';
import { GET_IDEA_URL, SUBMIT_IDEA_URL, GET_METADATA, APPROVED, PENDING, SENT_BACK, REJECTED, DATA_BRIDGE_CAMPAIGN, X_POLLINATION_CAMPAIGN, ACCESS_TOKEN, USER_DATA, AIFIRST, AI_DOC_LINK, GENAIOPTIONS, DISPLAYPROJECTTHEME, } from '../assets/constants/constants';
import Toast from 'light-toast';
import Select from 'react-select';
import { selectValidation as selectStyle, textBoxValidation } from "../utils/FieldValidation";
import UpdatedSpeech from './UpdatedSpeech'

export class EditIdeaPage extends Component {
    sessionData = JSON.parse(localStorage.getItem(USER_DATA));
    accessToken = localStorage.getItem(ACCESS_TOKEN);

    constructor(props) {
        super(props)
        let propsData = this.props.location;
        this.state = {
            ideaItem: {},
            campaignName: "",
            serviceLineSelectedOption: null,
            subServiceLineSelectedOption: null,
            showAdditionalDetails: false,
            serviceLineList: [],
            subServiceLineList: [],
            selectStyle: {},
            reviewComments: [],
            propsData: propsData,
            speechModal: false,
            transcriptValue: "",
            modalIndex: "",
            previousTextForSpeech: "",
            ServiceLineName: '',
            SubServiceLine: "",
            IdeaName: "",
            Problem: "",
            Solution: "",

            clusterData: [],
            isClusterSaveDisabled: true,
            displayParentAlpha: '',
            projectTypeSelectedOption: null,
            projectIDSelectedOption: null,
            BlackBeltUserId: 111,
            BlackBeltUserName: "",
            BlackBeltUserEmail: "",
            blackBeltSelectedOption: null,
            blackbeltList: [],

            campaignInsight: "",
            subCampaignList: [],


            DisplayAIFirst: false,


            ideasAI: [],

            campaignUnionQuery: null,
            displaySubCampaign: false,
            displayProjectTheme: false,
            dataBridgeProjectTheme: "",


        }
    }

    async componentDidMount() {
        await this.fetchIdea();
        await this.fetchMetadata();
    }

    fetchMetadata = async () => {
        try {
            const param = {
                EntityType: "",
                EntityName: ""
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };

            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    this.setState({
                        serviceLineList: data ? data.ServiceLines : [],
                        subServiceLineList: data ? data.ServiceLines : [],
                        subCampaignList: data ? data.SubCampaigns : [],
                        databridgeThemeList: data ? data.DataBridgeThemes : [],
                    }, () => {
                        this.setSelectedOptions();
                    })

                }

            }
        } catch (error) {
            console.log(JSON.stringify(error));
            Toast.fail('Error occured while getting metadata idea. Please try again!', 3000, () => { });
            Toast.hide()

        }
    }
    renderBlackBeltOptions = () => {

        let options = [];
        let result = [];
        this.state.blackbeltList.map((item) => {
            const userRole = JSON.parse(item.pg_Role).pg_role;
            if (userRole === "BB" || userRole === "QA") {
                if (this.state.ownerOHR !== item.pg_ohr) {
                    options.push({ value: item.pg_ohr, label: item.pg_username });
                }
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);
        return result
    }
    // Code change bh TR - sugg by AB


    fetchBlackBeltOptions = async () => {
        try {
            Toast.loading("Fetching Blackbelts. Please wait...", () => { });
            let entityType = "BB";
            let entityName = this.state.ideaItem.RegionManual;
            if (this.state.ideaItem.RegionManual === "Other Regions") {
                entityType = "BBOTHER";
                //DNA table has vertical with space around dash (' - ') whereas User Role table has NO space around dash ('-')
                entityName = this.state.ideaItem.VerticalManual.replace(" - ", "-");
            }
            const param = {
                EntityType: entityType,
                EntityName: entityName,
            };
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.accessToken
                },
                body: JSON.stringify(param)
            };

            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.hide();
                    console.log(data)
                    this.setState({
                        blackbeltList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
                        // mbbList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
                        // ldaList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
                    });
                }
            }
        } catch (error) {
            Toast.hide();
            Toast.fail('Error occured while getting BlackBelt details. Please try again!', 15000, () => {
                console.log(JSON.stringify(error));
            });

        }
    }
    handleBlackBeltNameChange = (e) => {
        if (parseInt(e.value) === parseInt(this.sessionData.profile.oHRId)) {
            Toast.fail('Mentor user cannot be the same as Idea Owner/Requester. Please select a different Mentor user.', 3000, () => {
                return;
            });
            return;
        }
        let styleStateObj = this.state.selectStyle;
        styleStateObj.blackBeltSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            BlackBeltUserId: e.value,
            BlackBeltUserName: e.label,
            BlackBeltUserEmail: e.value + "@genpact.com",
            blackBeltSelectedOption: e
        }, () => {
        });
    }
    setSelectedOptions = () => {
        this.state.serviceLineList.map((item) => {
            if (this.state.ideaItem.ServiceLineName === item.ServiceLineName) {
                this.setState({
                    serviceLineSelectedOption: {
                        value: item.ServiceLineId,
                        label: item.ServiceLineName
                    }
                })
            }
            return 1;
        });
        this.state.subServiceLineList.map((item) => {
            if (this.state.ideaItem.SubServiceLine === item.SubServiceLineName) {
                this.setState({
                    subServiceLineSelectedOption: {
                        value: item.SubServiceLineId,
                        label: item.SubServiceLineName
                    }
                })
            }
            return 1;
        });

        if (this.state.displayProjectTheme && this.state.campaignSelectedOption?.label === DATA_BRIDGE_CAMPAIGN) {
            this.state.databridgeThemeList && this.state.databridgeThemeList.map((item) => {
                if (this.state.ideaItem.DataBridgeTheme === item.DBProjectThemeName) {
                    this.setState({
                        dataBridgeProjectTheme: item.DBProjectThemeName,
                        databridgeThemeSelectedOptions: {
                            value: item.ThemeId,
                            label: item.DBProjectThemeName,
                        },
                    });
                }
                return 1;
            });
        }


    }

    fetchIdea = async () => {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.loading("Fetching Idea and Metadata...", () => { });
                    console.log("data", data);
                    this.setState({
                        ideaItem: data.ResultSets.Table1[0],
                        reviewComments: data.ReviewComments.Table1,
                        ServiceLineName: data.ResultSets.Table1[0].SubServiceLine ? data.ResultSets.Table1[0].ServiceLineName : "",
                        SubServiceLine: data.ResultSets.Table1[0].SubServiceLine ? data.ResultSets.Table1[0].SubServiceLine : "",
                        IdeaName: data.ResultSets.Table1[0].IdeaName ? data.ResultSets.Table1[0].IdeaName : "",
                        Problem: data.ResultSets.Table1[0].Problem ? data.ResultSets.Table1[0].Problem : "",
                        Solution: data.ResultSets.Table1[0].Solution ? data.ResultSets.Table1[0].Solution : "",
                        clusterData: data.ClusterData ? data.ClusterData : [],
                        ideasAI: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0] : [] : [],
                        campaignUnionQuery: data.CampaignDetails.ResultSets.Table1,

                    }, () => {
                        if (this.state.campaignUnionQuery) {
                            let filteredUnionQuery = this.state.campaignUnionQuery.filter((item) => {
                                return item.CampaignID === this.state.ideaItem.CampaignID
                            })
                            if (filteredUnionQuery) {
                                if (filteredUnionQuery[0]) {
                                    this.setState({
                                        campaignInsight: filteredUnionQuery[0].CampaignDescr,
                                        campaignSelectedOption: {
                                            value: filteredUnionQuery[0].CampaignID,
                                            label: filteredUnionQuery[0].Campaign,
                                        },
                                    }, () => { }
                                    );
                                }

                            }

                            if (this.state.ideaItem.CampaignName === "Gen AI") {
                                GENAIOPTIONS.map((item) => {
                                    if (item.label === this.state.ideaItem.SubCampaignName) {
                                        this.setState({
                                            subCampaignOption: item,
                                            displaySubCampaign: true
                                        }, () => { });
                                    }
                                });
                            } else {
                                // from union query - 
                                let options = [];
                                let result = [];
                                this.state.campaignUnionQuery.map((item) => {
                                    if (this.state.ideaItem.CampaignID === item.CampaignID) {
                                        if (item.SubCampaign) {
                                            options.push({ value: item.SubCampaignID, label: item.SubCampaign });
                                        }
                                    }
                                    return true;
                                });
                                result = options.reduce((unique, index) => {
                                    if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                                        unique.push(index);
                                    }
                                    return unique;
                                }, []);
                                if (result.length > 0) {
                                    this.setState({ displaySubCampaign: true }, () => { })
                                    result.map((item) => {
                                        if (this.state.ideaItem.SubCampaignID === item.value) {
                                            this.setState({ subCampaignOption: item });
                                        }
                                    })
                                }
                            }

                        }

                        if (this.state.ideaItem.CreatedDate) {
                            let created = new Date(this.state.ideaItem.CreatedDate);
                            let abc = new Date(DISPLAYPROJECTTHEME);
                            if (created.getTime() < abc.getTime()) {
                                this.setState({ displayProjectTheme: true });
                            } else {
                                this.setState({ displayProjectTheme: false });

                            }
                        }

                        if (this.state.clusterData && this.state.clusterData.length > 0) {
                            const targetRecID = this.state.ideaItem.LeanID;
                            const filteredData = this.state.clusterData.filter(item => item.RecAlpha === targetRecID);
                            console.log(filteredData)
                            if (filteredData && filteredData.length > 0 && filteredData !== undefined && filteredData !== null) {
                                this.setState({ displayParentAlpha: filteredData[0].ParentAlpha }, () => { })
                                let options = [];
                                options.push({ value: 0, label: filteredData[0].ParentAlpha })
                                this.setState({ projectIDSelectedOption: options }, () => { })

                                let options1 = [];
                                options1.push({ value: 0, label: "GB" })
                                this.setState({ projectTypeSelectedOption: options1 }, () => { })
                            } else {
                                this.setState({ displayParentAlpha: "" }, () => { })
                            }
                        } else {
                            this.setState({ displayParentAlpha: "" }, () => { })
                        }

                        if (this.state.ideaItem.CampaignName === "Gen AI") {
                            GENAIOPTIONS.map((item) => {
                                if (item.label === this.state.ideaItem.SubCampaignName) {
                                    this.setState({ subCampaignName: item });
                                }
                            });
                        }

                        if (this.state.ideaItem.BlackBeltUserName && this.state.ideaItem.BlackBeltUserId) {
                            this.setState({
                                BlackBeltUserId: this.state.ideaItem.BlackBeltUserId,
                                BlackBeltUserName: this.state.ideaItem.BlackBeltUserName,
                                BlackBeltUserEmail: this.state.ideaItem.BlackBeltUserId + "@genpact.com",
                                blackBeltSelectedOption: {
                                    label: this.state.ideaItem.BlackBeltUserName,
                                    value: this.state.ideaItem.BlackBeltUserId
                                }
                            })
                        }
                        this.fetchBlackBeltOptions()
                    });
                }
            }

        } catch (error) {
            Toast.hide()
            console.log("Error =>", JSON.stringify(error))
            Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });

        }

    }

    validate = () => {
        let isValid = true;
        let styleStateObj = this.state.selectStyle;

        if (this.state.blackBeltSelectedOption === null ||
            this.state.blackBeltSelectedOption === undefined ||
            !this.state.blackBeltSelectedOption) {
            isValid = false;
            styleStateObj.blackBeltSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.blackBeltSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        if (this.state.ideaItem.NewOrReplicatedIdea && this.state.ideaItem.ReplicationProjectId === "") {
            isValid = false;
            styleStateObj.ReplicationProjectId = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            if (this.state.ideaItem.NewOrReplicatedIdea && this.state.ideaItem.ReplicationProjectId !== "") {
                if (!this.validateReplicationId(this.state.ideaItem.ReplicationProjectId)) {
                    isValid = false;
                    styleStateObj.ReplicationProjectId = textBoxValidation(false);
                    this.setState({
                        selectStyle: styleStateObj
                    })
                } else {
                    styleStateObj.ReplicationProjectId = { ...textBoxValidation(true), border: "1px solid lightgrey" };
                    this.setState({
                        selectStyle: styleStateObj
                    })
                }
            } else {
                styleStateObj.ReplicationProjectId = { ...textBoxValidation(true), border: "1px solid lightgrey" };
                this.setState({
                    selectStyle: styleStateObj
                })
            }
        }

        if (this.state.ideaItem.ServiceLineName === "") {
            isValid = false;
            styleStateObj.ServiceLineName = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.ServiceLineName = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (this.state.ideaItem.SubServiceLine === "") {
            isValid = false;
            styleStateObj.subServiceLine = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.subServiceLine = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (this.state.IdeaName === "") {
            isValid = false;
            styleStateObj.IdeaName = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.IdeaName = textBoxValidation(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (this.state.Problem === "") {
            isValid = false;
            styleStateObj.Problem = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            if (this.state.Problem.length > 2000) {
                Toast.fail("Problem statement cannot be more than 2000 characters, please change and resubmit.", 3000);
                isValid = false;
                styleStateObj.Problem = textBoxValidation(false);
                this.setState({
                    selectStyle: styleStateObj
                })
            } else {
                styleStateObj.Problem = { ...textBoxValidation(true), border: "1px solid lightgrey" };
                this.setState({
                    selectStyle: styleStateObj
                })
            }
        }

        if (this.state.Solution === "") {
            isValid = false;
            styleStateObj.Solution = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            if (this.state.Solution.length > 2000) {
                Toast.fail("Solution statement cannot be more than 2000 characters, please change and resubmit.", 3000);
                isValid = false;
                styleStateObj.Solution = textBoxValidation(false);
                this.setState({
                    selectStyle: styleStateObj
                })
            } else {
                styleStateObj.Solution = { ...textBoxValidation(true), border: "1px solid lightgrey" };
                this.setState({
                    selectStyle: styleStateObj
                })
            }
        }

        return isValid;
    }

    submitIdea = () => {
        let preworkflowstatus = "Pending";
        let workflowstatus = "Pending"
        
        if (this.validate()) {
            if (window.confirm("Are you sure you want to update the Idea?")) {
                Toast.loading("Updating Idea...", () => { });
                let param = {
                    IdeaName: this.state.IdeaName,
                    Problem: this.state.Problem,
                    Solution: this.state.Solution,
                    ServiceLineId: this.state.ideaItem.ServiceLineId,
                    ServiceLineName: this.state.ideaItem.ServiceLineName,
                    SubServiceLine: this.state.ideaItem.SubServiceLine,
                    NewOrReplicatedIdea: this.state.ideaItem.NewOrReplicatedIdea,
                    ReplicationProjectId: (this.state.ideaItem.NewOrReplicatedIdea) ? this.state.ideaItem.ReplicationProjectId : "",
                    IdeaId: this.props.location.state,
                    ModifiedByOHR: this.sessionData.profile.oHRId,
                    SaveType: "Edit",
                    BlackBeltUserId: Number(this.state.BlackBeltUserId) ? Number(this.state.BlackBeltUserId) : this.state.ideaItem.BlackBeltUserId,
                    BlackBeltUserName: this.state.BlackBeltUserName ? this.state.BlackBeltUserName : this.state.ideaItem.BlackBeltUserName,
                    BlackBeltUserEmail: this.state.BlackBeltUserEmail ? this.state.BlackBeltUserEmail : this.state.ideaItem.BlackBeltUserEmail,

                    PrevWorkflowStatus: preworkflowstatus,
                    WorkflowStatus: workflowstatus,

                    CampaignTypeId: this.state.campaignSelectedOption ? this.state.campaignSelectedOption.value : this.state.ideaItem.CampaignID,
                    CampaignName: this.state.campaignSelectedOption ? this.state.campaignSelectedOption.label : this.state.ideaItem.CampaignName,

                    SubCampaignName: this.state.subCampaignOption ? this.state.subCampaignOption.label : "",
                    SubCampaignID: this.state.subCampaignOption ? this.state.subCampaignOption.value : "",
                    DataBridgeTheme: this.state.dataBridgeProjectTheme ? this.state.dataBridgeProjectTheme : "",

                    

                }
                console.log(param)


                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + this.accessToken,
                    },
                    body: JSON.stringify(param)
                };
                fetch(`${SUBMIT_IDEA_URL}`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        Toast.hide();
                        Toast.success('Updated successfully.', 3000, () => {
                            console.log(JSON.stringify(data));
                            window.location = "/review-page";
                        });

                    });
            }
        } else {
            Toast.fail('Required fields are missing or have invalid values. Please correct and try again.', 3000, () => { });
        }
        return false;
    }

    handleIdeaNameChange = (text) => {
        this.setState({ IdeaName: text }, () => {
            console.log("idea name at onchange function", this.state.IdeaName)
        })
    }

    handleProblemChange = (text) => {
        this.setState({ Problem: text }, () => { console.log("Problem text updated", this.state.Problem) })
    }

    handleSolutionChange = (text) => {
        this.setState({
            Solution: text
        }, () => {
            console.log("solution text updated", this.state.Solution)
        });
    }

    showHideDiv = () => {
        let ideaItem = this.state.ideaItem;
        ideaItem.NewOrReplicatedIdea = !ideaItem.NewOrReplicatedIdea;
        this.setState({
            ideaItem
        });
    }

    handleReplicationIdChange = (text) => {
        let ideaItem = this.state.ideaItem;
        ideaItem.ReplicationProjectId = text;
        this.setState({
            ideaArray: ideaItem
        });
    }

    renderServiceLineOptions = () => {
        let options = [];
        const uniqueServiceLineList = [...new Map(this.state.serviceLineList.map(item =>
            [item.ServiceLineName, item])).values()];
        uniqueServiceLineList.map((item) => {
            options.push({ value: item.ServiceLineId, label: item.ServiceLineName });
            return true;
        });
        return options;
    }

    renderSubServiceLineOptions = () => {
        let options = [];

        this.state.subServiceLineList.map((item) => {
            if (this.state.ideaItem.ServiceLineName === item.ServiceLineName) {
                options.push({ value: item.SubServiceLineId, label: item.SubServiceLineName });
                return true;
            }
            return true;
        });
        return options;
    }

    handleServiceLineChange = (e) => {
        let ideaItem = this.state.ideaItem;
        ideaItem.ServiceLineId = e.value;
        ideaItem.ServiceLineName = e.label;
        ideaItem.SubServiceLineId = "";
        ideaItem.SubServiceLine = "";
        this.setState({
            subServiceLineSelectedOption: null,
            serviceLineSelectedOption: {
                value: e.value,
                label: e.label
            },
            ideaItem
        });
        this.renderSubServiceLineOptions(e);
    }

    handleSubServiceLineChange = (e, index) => {
        let ideaItem = this.state.ideaItem;
        ideaItem.SubServiceLine = e.label;
        this.setState({
            subServiceLineSelectedOption: {
                value: e.value,
                label: e.label
            },
            ideaItem
        });

    }

    fetchReplicationIdeaDetails = async (IdeaId) => {
        try {
            Toast.loading("Fetching Replication Idea Details. Please wait...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            const response = await fetch(`${GET_IDEA_URL}IdeaId=-1&IdeaIDAlpha=${IdeaId}&case=data&casetype=fetchIdeaDetails`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    if (data.ResultSets.Table1 === undefined) {
                        Toast.fail("We could not find Idea details based on the entered Idea ID. Please check and re-enter.", 5000, () => { });
                        return false;
                    } else {
                        Toast.hide();
                        Toast.success('Replication Idea ID validated successfully!', 3000, () => { });
                        return true;
                    }
                }
            }
        } catch (error) {
            console.log(error)
            Toast.hide();
            Toast.fail("Could not find the Idea, please check and re-enter correct Idea ID.", 5000, () => { });
            return false;

        }
    }

    validateReplicationId = () => {
        if (!this.fetchReplicationIdeaDetails(this.state.ideaItem.ReplicationProjectId)) {
            let ideaItem = this.state.ideaItem;
            ideaItem.ReplicationProjectId = "";
            this.setState({
                ideaItem: ideaItem
            });
            return false;
        } else {
            return true;
        }
    }

    cancelEvent = () => {
        // this.props.history.push("/review-page");
        let redirectURL = "/review-page";
        this.props.history.push({
            pathname: redirectURL,
            propsList: this.state.propsData
        })
    }

    formatDateStringWithTime(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }

    handleEditTranscriptProblemChange = (text) => {
        if (text !== null && text !== undefined) {
            this.setState({ Problem: text }, () => {
                console.log("at handle transcript problem", this.state.Problem)
            })
        }
    }
    handleEditTranscriptSolutionChange = (text) => {
        if (text !== null && text !== undefined) {
            this.setState({
                Solution: text
            }, () => { });
        }
    }
    toggleTranscriptFunction = (id) => {
        this.setState({ speechModal: !this.state.speechModal, modalIndex: id })
        this.setState({ previousTextForSpeech: this.state.Problem }, () => console.log(this.state.previousTextForSpeech))
        if (id === 5) {
            this.setState({ previousTextForSpeech: this.state.Problem }, () => console.log(this.state.previousTextForSpeech))
        }
        if (id === 6) {
            this.setState({ previousTextForSpeech: this.state.Solution }, () => console.log(this.state.previousTextForSpeech))
        }
    }

    closeModalFunction = () => {
        this.setState({ speechModal: false })
    }

    renderCampaignOptions = () => {
        let options = [];
        let result = [];
        this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
            options.push({ value: item.CampaignID, label: item.Campaign });
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);
        return result
    };


    handleCampaignNameChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.campaignSelectedOption = selectStyle(true);

        this.setState({
            IsIdeaReplicableSelectedOption: [],
            replicabilitySelectedOption: [],
            solutionFeasibleSelectedOption: [],
            solutionComplexitySelectedOption: [],
            dataBridgeProjectTheme: "",
            databridgeThemeSelectedOptions: [],
            subCampaignOption: null,
            selectStyle: styleStateObj,
            campaignSelectedOption: {
                value: e.value,
                label: e.label,
            },
        }, () => { });

        if (e.label === "AI First") {
            this.setState({ DisplayAIFirst: true }, () => { })
        } else {
            this.setState({ DisplayAIFirst: false }, () => { })
        }


        // below code will check the union query and will set subcampaign to true if the union query contains the subcampaign query
        let options = [];
        let result = [];
        this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
            if (e.value === item.CampaignID) {
                this.setState({ campaignInsight: item.CampaignDescr }, () => { })
                if (item.SubCampaign) {
                    options.push({ value: item.SubCampaignID, label: item.SubCampaign });
                }
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);

        if (result.length > 0) {
            this.setState({ displaySubCampaign: true }, () => { })
        } else {
            this.setState({ displaySubCampaign: false }, () => { })
        }
    };

    renderSubCampaignOptions = () => {
        if (this.state.campaignSelectedOption?.label === "Gen AI") {
            return GENAIOPTIONS;
        } else {
            let options = [];
            let result = [];
            this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
                if (this.state.campaignSelectedOption?.value === item.CampaignID) {
                    options.push({ value: item.SubCampaignID, label: item.SubCampaign });
                }
                return true;
            });
            result = options.reduce((unique, index) => {
                if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                    unique.push(index);
                }
                return unique;
            }, []);
            return result
        }
    };


    handleSubCampaignChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.subCampaignOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            subCampaignOption: e,
        }, () => { });
    };

    renderDataBridgeThemeOptions = () => {
        let options = [];
        this.state.databridgeThemeList && this.state.databridgeThemeList.map((item) => {
            options.push({
                value: item.ThemeId,
                label: item.DBProjectThemeName,
            });
            return options;
        });
        return options;
    };
    handleDataBridgeProjectThemeChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.dataBridgeProjectTheme = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            dataBridgeProjectTheme: e.label,
            databridgeThemeSelectedOptions: {
                value: e.label,
                label: e.label,
            },
        });
    };


    render() {
        let IDEA_APPROVED = (this.state.ideaItem.WorkflowStatus === "Approve");
        let IDEA_REJECTED = (this.state.ideaItem.WorkflowStatus === "Reject");
        let IDEA_SEND_BACK = (this.state.ideaItem.WorkflowStatus === "Send Back");
        return (
            <>
                <section className="u-clearfix u-section-1" id="sec-0f7f">
                    <div className="u-clearfix u-sheet u-sheet-1" style={{ marginBottom: 20 }}>
                        <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
                            <div className="u-container-layout u-container-layout-1">
                                <h4 style={{ textAlign: 'center', color: '#00AECF', fontFamily: 'Arial', fontSize: 22 }}>Edit  idea : {this.state.ideaItem.IdeaIDAlpha ? this.state.ideaItem.IdeaIDAlpha : this.state.ideaItem.IdeaId} </h4>
                                <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                                    <div className="u-container-layout u-container-layout-2" style={{ textAlign: 'center' }}>
                                        <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-3">
                                            <div className="u-container-layout u-container-layout-3">
                                                <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Owner details</p>
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Owner OHR</label> </div>
                                                    <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.OwnerOHR} /></div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Owner Name</label> </div>
                                                    <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.OwnerName} /></div>
                                                </div>
                                                <div style={{ marginBottom: -10 }} />
                                                <p className="u-align-left u-text u-text-7 u-text-custom-color-3" style={{ fontSize: 11, marginBottom: 10 }}>(If Idea was raised for someone else, their OHR ID is below)</p>
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Request For OHR</label> </div>
                                                    <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.CreatorOHR} /></div>
                                                </div>
                                                <div style={{ marginBottom: 10 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Name</label> </div>
                                                    <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.CreatorName} /></div>
                                                </div>
                                                <div style={{ marginBottom: 10 }} />
                                                {/* <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Project ID</label> </div>
                                                    <div className="col-md-6"><input className ="form-input" disabled type="text" defaultValue={this.state.ideaItem.LeanID}/></div>
                                                </div> */}
                                                <div style={{ marginBottom: 10 }} />
                                            </div>
                                        </div>

                                        <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 235 }}>&nbsp;</p>

                                        <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-4" style={{ marginTop: "-251px" }}>
                                            <div className="" style={{ display: "flex", marginTop: "30px" }}>
                                                <div className="u-container-style u-group u-shape-rectangle u-group-5">
                                                    <div className="u-container-layout u-container-layout-5">
                                                        <p className="u-align-left u-text u-text-8" style={{ marginBottom: 15 }}>Account Details</p>
                                                        <div className="row">
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Account&nbsp;Name</label></div>
                                                            <div className="col-md-7">
                                                                <input className="form-input" disabled list="accounts" name="accounts" placeholder="Choose Account" value={this.state.ideaItem.AccountManual} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row">
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Holding&nbsp;Account</label></div>
                                                            <div className="col-md-7">
                                                                <input className="form-input" disabled type="text" value={this.state.ideaItem.HoldingAccount} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row">
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Vertical</label></div>
                                                            <div className="col-md-7">
                                                                <input className="form-input" disabled list="vertical" name="vertical" placeholder="Choose Vertical" value={this.state.ideaItem.VerticalManual} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row">
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Industry&nbsp;Vertical</label></div>
                                                            <div className="col-md-7">
                                                                <input className="form-input" disabled list="ideationtype" name="ideationtype" placeholder="Choose Industry&nbsp;Vertical" value={this.state.ideaItem.SubVerticalName} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />

                                                        {/* units and segments starts here */}
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Segment</label>
                                                            </div>
                                                            <div className="col-md-7">
                                                                <input className="form-input" disabled name="segment" value={this.state.ideaItem.Segment ? this.state.ideaItem.Segment : ""} style={{ fontWeight: 'normal !important' }} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Unit</label>
                                                            </div>
                                                            <div className="col-md-7">
                                                                <input className="form-input" disabled name="unit" value={this.state.ideaItem.Unit ? this.state.ideaItem.Unit : ""} style={{ fontWeight: 'normal !important' }} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        {/* units and segments ends here */}


                                                        <div className="row">
                                                            <div className="col-md-5"><span className="form-attribute">Campaign&nbsp;Name</span></div>
                                                            <div className="col-md-7">
                                                                <Select
                                                                    isSearchable={true}
                                                                    options={this.renderCampaignOptions()}
                                                                    styles={this.state.selectStyle.campaignSelectedOption}
                                                                    placeholder="Choose Campaign"
                                                                    onChange={this.handleCampaignNameChange}
                                                                    value={this.state.campaignSelectedOption}
                                                                />

                                                            </div>
                                                            <div className="">
                                                                <div className="campaign_modal_bulb campaign_tool_tip">
                                                                    <img
                                                                        src={require("../assets/images/question_mark_2.png")}
                                                                        alt=""
                                                                        className=""
                                                                    />
                                                                    {
                                                                        this.state.campaignInsight
                                                                            ?
                                                                            <>
                                                                                <span className="my_tooltiptext">{this.state.campaignInsight}</span>
                                                                            </>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />

                                                        {
                                                            (this.state.displaySubCampaign || this.state.campaignSelectedOption?.label === "Gen AI") && (
                                                                <>
                                                                    <div className="row" style={{ marginBottom: 15 }}>
                                                                        <div className="col-md-5">
                                                                            <label style={{ verticalAlign: "bottom", }}>
                                                                                {
                                                                                    this.state.campaignSelectedOption?.label === "Gen AI"
                                                                                        ?
                                                                                        "Gen AI Theme"
                                                                                        :
                                                                                        "Sub Campaign"
                                                                                }
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-7">
                                                                            <Select
                                                                                isSearchable={true}
                                                                                options={this.renderSubCampaignOptions()}
                                                                                placeholder="Choose Sub Campaign"
                                                                                value={this.state.subCampaignOption}
                                                                                onChange={this.handleSubCampaignChange}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        }


                                                        {
                                                            this.state.displayProjectTheme && this.state.campaignSelectedOption?.label === DATA_BRIDGE_CAMPAIGN && (
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col-md-5" >
                                                                            <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                                                                DataBridge Project Theme
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-7">
                                                                            <Select
                                                                                isSearchable={true}
                                                                                options={this.renderDataBridgeThemeOptions()}
                                                                                styles={this.state.selectStyle.dataBridgeProjectTheme}
                                                                                placeholder="Choose Project Theme"
                                                                                value={this.state.databridgeThemeSelectedOptions}
                                                                                onChange={this.handleDataBridgeProjectThemeChange}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ marginBottom: 15 }} />
                                                                </>
                                                            )}

                                                        {
                                                            this.state.displayParentAlpha && this.state.displayParentAlpha.length > 0 && this.state.displayParentAlpha !== null && this.state.displayParentAlpha !== undefined && this.state.displayParentAlpha !== ""
                                                                ?
                                                                <>
                                                                    <div className="row" style={{ marginBottom: "15px" }}>
                                                                        <div className="col-md-5">
                                                                            <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Parent ID</label>
                                                                        </div>
                                                                        <div className="col-md-7">
                                                                            <input className="form-input" disabled placeholder="Choose Parent ID" value={this.state.displayParentAlpha} />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                null
                                                        }


                                                        {
                                                            this.state.campaignSelectedOption && this.state.campaignSelectedOption.label === AIFIRST
                                                                ?
                                                                <>
                                                                    <div className="row" style={{ marginTop: "15px" }}>
                                                                        <div className="col-md-5">
                                                                            <label
                                                                                style={{
                                                                                    verticalAlign: "bottom",
                                                                                    marginBottom: -5,
                                                                                }}
                                                                            >
                                                                                <i>AI First Sample Ideas</i>
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-7">
                                                                            <div className="ai_first_doc_link ai_first_doc_red_highlight">
                                                                                <a
                                                                                    className="ldt-list1"
                                                                                    href={AI_DOC_LINK}
                                                                                    target="_blank"
                                                                                    rel="noreferrer"
                                                                                    style={{ textAlign: "left", fontSize: 16, color: "red" }}
                                                                                >Document Link </a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                null
                                                        }


                                                        {
                                                            this.state.campaignSelectedOption && this.state.campaignSelectedOption.label === AIFIRST
                                                                && this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                                ?
                                                                <>
                                                                    <div style={{ marginBottom: 20 }} />
                                                                    <div className="row d_flex_align_items_center">
                                                                        <div className="col-md-5">
                                                                            <span className="form-attribute">
                                                                                AI Recommendation
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-7">
                                                                            <input
                                                                                className="form-input"
                                                                                disabled
                                                                                name="methodology"
                                                                                value={this.state.ideaItem.isAI}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                null

                                                        }


                                                        {
                                                            this.state.campaignSelectedOption && this.state.campaignSelectedOption.label === AIFIRST &&
                                                                this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                                ?
                                                                <>
                                                                    <div style={{ marginBottom: 20 }} />
                                                                    <div className="row">
                                                                        <div className="col-md-5">
                                                                            <span className="form-attribute">
                                                                                AI First BRD
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-7">
                                                                            <div className="ai_first_doc_link">
                                                                                <textarea className="ai_first_brd_textarea" disabled value={this.state.ideasAI.LinkBRD} ></textarea>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                null
                                                        }


                                                    </div>
                                                </div>
                                                <div className="u-container-layout u-container-layout-6">

                                                    <div className="row" style={{ marginTop: "10px" }}>
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Country</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="country" name="country" placeholder="Choose Country" value={this.state.ideaItem.Country} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Region</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="regions" name="regions" placeholder="Choose Region" value={this.state.ideaItem.RegionManual} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub-Region</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="subregions" name="subregions" placeholder="Choose Sub-Region" value={this.state.ideaItem.SubRegion} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Blackbelt&nbsp;Name</label></div>
                                                        <div className="col-md-7">
                                                            <Select isSearchable={true} value={this.state.blackBeltSelectedOption} options={this.renderBlackBeltOptions()} styles={this.state.selectStyle.blackBeltSelectedOption} placeholder="Choose Blackbelt" onChange={this.handleBlackBeltNameChange} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>MBB</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="blackbelt" placeholder="Choose MBB" title={"OHR ID: " + this.state.ideaItem.MBBOHR} value={this.state.ideaItem.MBBName} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    {
                                                        this.state.campaignSelectedOption && this.state.campaignSelectedOption.label === AIFIRST &&
                                                            this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                            ?
                                                            <>
                                                                <div style={{ marginBottom: 20 }} />
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <span className="form-attribute">
                                                                            AI First Reason
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <textarea
                                                                            disabled
                                                                            value={this.state.ideasAI.AIReason}
                                                                            placeholder="Please provide value"
                                                                            className="form-input"
                                                                            rows={4}
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid lightgrey",
                                                                                resize: "none"
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginBottom: 20 }} />
                                                            </>
                                                            :
                                                            null
                                                    }
                                                    <div style={{ marginBottom: 15 }} />
                                                </div>
                                            </div>
                                        </div>



                                        {
                                            (this.state.ideaItem.WorkflowStatus && this.state.ideaItem.WorkflowStatus !== "Pending") && (
                                                <>
                                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: -40 }}>&nbsp;</p>

                                                    <div id="Approval Status" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ marginTop: 15 }}>
                                                        <div className="u-container-layout u-container-layout-7" style={{ borderTop: "1px solid lightgrey", borderBottom: "1px solid lightgrey" }}>
                                                            <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}> Idea Approval details</p>
                                                            <div className="row">
                                                                <div className="col-md-2"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Approval Status</label></div>
                                                                <div className="col-md-2">
                                                                    <input className="form-input" disabled name="Status" value={IDEA_APPROVED ? APPROVED : (IDEA_REJECTED ? REJECTED : (IDEA_SEND_BACK ? SENT_BACK : PENDING))} />
                                                                </div>
                                                                {/* <div className="col-md-3"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Expected timeline for execution</label></div>
                                                                <div className="col-md-2">
                                                                    <input disabled name="ExpectedDate" value={this.state.ideaItem.ExpectedFinishDate ? this.formatDateString(new Date(this.state.ideaItem.ExpectedFinishDate)) : ""} />
                                                                </div> */}
                                                            </div>
                                                            <div className="col-md-9" style={{ marginBottom: 5, width: "100%" }} />
                                                            {/* <div className="row">
                                                                <div className="col-md-12">
                                                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                                        <span className="u-text-black form-attribute">Comments</span>
                                                                    </p>
                                                                </div>
                                                            </div> */}
                                                            {/* <div className="row">
                                                                <div className="col-md-12">
                                                                    <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.Comment} />
                                                                </div>
                                                            </div> */}
                                                            <div className="row" style={{ marginTop: 15 }}>
                                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Comments</label></div>
                                                                <div className="col-md-2" style={{ marginLeft: 20 }}>
                                                                    <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.setState({ commentLog: !this.state.commentLog })}>Comment Log</button>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginTop: 5 }}>
                                                                <div className="col-md-12">
                                                                    <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.Comment} />
                                                                </div>
                                                            </div>
                                                            <div className="text-left mt-4">
                                                                {
                                                                    this.state.commentLog && this.state.reviewComments
                                                                        ?
                                                                        <>
                                                                            <div className="custom_modal">
                                                                                <div className="modal_body">
                                                                                    <div className="row">
                                                                                        <div className="col-md-8">
                                                                                            <h3 className="modal_title">Idea Approval Comment Log</h3>
                                                                                        </div>
                                                                                        <div className="col-md-4">
                                                                                            <button type="button" className="close text-right" onClick={(e) => this.setState({ commentLog: false })}>&times;</button>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row">
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                                        </div>
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                                        </div>
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                                        </div>
                                                                                        <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                                        </div>
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                                        </div>
                                                                                        <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        this.state.reviewComments.map((item, index) => {

                                                                                            return (
                                                                                                <div className="row" key={index}>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-1 text-center role_over_flow_class" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole ? item.UpdaterRole : (item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === 'Delegate Action' ? 'BB' : (item.UpdaterOHR === this.state.ideaItem.BlackBeltUserId ? "BB" : (item.UpdaterOHR === this.state.ideaItem.MBBOHR ? "MBB" : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Owner" : "LDT"))))}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterAction ? item.UpdaterAction : item.Action === 'Idea Reinitiated by Admin' ? 'Idea Reinitiated' : (item.Action === 'Idea Updated by Admin' ? (item.WorkflowStatus !== 'Pending' ? item.WorkflowStatus : 'Idea Updated') : (item.Action === 'Delegate Action' ? 'Delegated' : (item.WorkflowStatus === 'Pending' ? 'Reject Cancellation' : item.WorkflowStatus)))}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment !== '' ? item.Comment : '-'}</label>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 15 }}>&nbsp;</p>
                                                </>
                                            )
                                        }

                                        <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: -80 }}>&nbsp;</p>

                                        <div id="idea1" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ marginTop: 15 }}>
                                            <div className="u-container-layout u-container-layout-7">
                                                <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                    <div className="u-container-layout u-container-layout-8">
                                                        <p id="idea1title" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Idea details</p>
                                                        <div className="row">
                                                            <div className="col-md-4"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}><span style={{ color: 'red' }}>*</span> Service&nbsp;Line</label></div>
                                                            <div className="col-md-8">
                                                                <Select isSearchable={true} options={this.renderServiceLineOptions(this.state.serviceLineSelectedOption)} styles={this.state.selectStyle.serviceLineText} placeholder="Choose Service Line" value={this.state.serviceLineSelectedOption} onChange={(e) => this.handleServiceLineChange(e)} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row">
                                                            <div className="col-md-4"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}><span style={{ color: 'red' }}>*</span> Sub-Service&nbsp;Line</label></div>
                                                            <div className="col-md-8">
                                                                <Select isSearchable={true} options={this.renderSubServiceLineOptions()} styles={this.state.selectStyle.subServiceLine} placeholder="Choose Sub Service Line" value={this.state.subServiceLineSelectedOption} onChange={(e) => this.handleSubServiceLineChange(e)} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />

                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <p className="u-align-left u-text u-text-custom-color-4 u-text-8">
                                                                    <span className="u-text-black form-attribute" style={{ fontWeight: 'normal' }}><span style={{ color: 'red' }}>*</span>&nbsp; What is the Problem ?&nbsp;<span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}>(max. 2000 chars)</span></span>
                                                                </p>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="" style={{ display: 'flex', justifyContent: "flex-end" }}>
                                                                    <img onClick={(e) => this.toggleTranscriptFunction(5)} src={require("../assets/images/voice.png")} className="w100" alt="" style={{ width: "24px", cursor: "pointer" }} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* <p className="u-align-left u-text u-text-custom-color-4 u-text-8">
                                                            <span className="u-text-black form-attribute"><span style={{ color: 'red' }}>*</span>&nbsp;Problem&nbsp;<span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}>(max. 2000 chars)</span></span>
                                                        </p> */}
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <textarea className="textarea-css form-attribute" rows={6} cols={80} style={{ maxWidth: '100%', border: '1px solid lightgrey', ...this.state.selectStyle.Problem }} value={this.state.Problem} onChange={(event) => this.handleProblemChange(event.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.speechModal
                                                            ?
                                                            // <SpeechToText modalOpen={true} onData={ this.handleTranscriptProblemChange} modalId={this.state.modalIndex} closeModalFunction={this.closeModalFunction} ideaArrayIndex={index}  />
                                                            <UpdatedSpeech modalOpen={true}
                                                                onEditTranscriptProblem={this.handleEditTranscriptProblemChange}
                                                                onEditTranscriptSolution={this.handleEditTranscriptSolutionChange}
                                                                modalId={this.state.modalIndex}
                                                                closeModalFunction={this.closeModalFunction}
                                                                previousText={this.state.previousTextForSpeech}
                                                            />
                                                            :
                                                            null
                                                    }
                                                </div>
                                                <div className="u-container-style u-group u-shape-rectangle u-group-9">
                                                    <div className="u-container-layout u-container-layout-9" style={{ marginTop: -5 }}>
                                                        <div className="row">
                                                            <div className="col-md-4"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}><span style={{ color: 'red' }}>*</span> Idea Name</label> </div>
                                                            <div className="col-md-8" style={{ alignItems: 'flex-start' }}><input className="textarea-css form-attribute" type="text" value={this.state.IdeaName} style={this.state.selectStyle.IdeaName} placeholder="Eg: Cash flow improvement through process restructuring" onChange={(event) => this.handleIdeaNameChange(event.target.value)} /></div>
                                                        </div>
                                                        <div style={{ marginBottom: 17 }} />
                                                        <div style={{ marginTop: 50 }}>&nbsp;</div>

                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <p className="u-align-left u-text u-text-custom-color-4 u-text-8">
                                                                    <span className="u-text-black form-attribute" style={{ fontWeight: 'normal' }}><span style={{ color: 'red' }}>*</span>&nbsp; How to resolve the problem&nbsp;<span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}>(max. 2000 chars)</span></span>
                                                                </p>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="" style={{ display: 'flex', justifyContent: "flex-end" }}>
                                                                    <img onClick={(e) => this.toggleTranscriptFunction(6)} src={require("../assets/images/voice.png")} className="w100" alt="" style={{ width: "24px", cursor: "pointer" }} />
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* <p className="u-align-left u-text u-text-custom-color-4 u-text-8">
                                                            <span className="u-text-black form-attribute"><span style={{ color: 'red' }}>*</span>&nbsp;Solution&nbsp;<span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}>(max. 2000 chars)</span></span>
                                                        </p> */}
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <textarea className="textarea-css form-attribute" rows={6} cols={80} style={{ maxWidth: '100%', border: '1px solid lightgrey', ...this.state.selectStyle.Solution }} value={this.state.Solution} onChange={(event) => this.handleSolutionChange(event.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 17 }} />
                                                    </div>
                                                </div>

                                                <div className="row" style={{ marginTop: 30 }} >
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}><label style={{ color: 'red' }}>*</label> Are you trying to replicate an existing Idea?</label>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="switch">
                                                            <input type="checkbox" checked={this.state.ideaItem.NewOrReplicatedIdea === null ? false : this.state.ideaItem.NewOrReplicatedIdea} onChange={() => this.showHideDiv()} />
                                                            <span className="slider round" />
                                                        </label>
                                                    </div>
                                                </div>

                                                {
                                                    this.state.ideaItem.NewOrReplicatedIdea && (
                                                        <>

                                                            <div className="row" id="ReplicatedProjectId">
                                                                <div className="col-md-8" style={{ marginBottom: 15 }} />
                                                                <div className="col-md-5"><span className="form-attribute"> <span style={{ color: 'red' }}>*</span> Provide the ID of the executed Idea which you
                                                                    want to replicate?</span></div>
                                                                <div className="col-md-2">
                                                                    <input className="textarea-css form-attribute" type="text" value={this.state.ideaItem.ReplicationProjectId} style={{ border: '1px solid lightgrey', ...this.state.selectStyle.ReplicationProjectId }} onChange={event => { this.handleReplicationIdChange(event.target.value) }} onKeyPress={event => {
                                                                        if (event.key === 'Enter') {
                                                                            this.validateReplicationId();
                                                                        }
                                                                    }} />
                                                                </div>
                                                                <div className="col-md-1"><i className="fa fa-check-square-o" style={{ marginTop: 5, color: '#FF555F', fontSize: 24 }} onClick={event => { this.validateReplicationId() }} /></div>
                                                                <div className="col-md-8" style={{ marginBottom: 15 }} />
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                <div className="col-md-8" style={{ marginTop: 5, marginBottom: 15 }} />
                                            </div>
                                        </div>

                                        <div className="" style={{ borderTop: "1px solid lightgrey", margin: "15px 0px" }} />

                                        <div className="btn-group">
                                            <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.submitIdea}>Save</button>
                                            <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={this.cancelEvent}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default EditIdeaPage
